declare namespace $ {

	type $bog_theme_auto__theme_light_bog_max_app_1 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_theme_auto['theme_light'] >
	>
	type $bog_theme_auto__theme_dark_bog_max_app_2 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_theme_auto['theme_dark'] >
	>
	type $bog_theme_auto__themes_bog_max_app_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_theme_auto['themes'] >
	>
	type $mol_image__uri_bog_max_app_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_image__title_bog_max_app_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_image['title'] >
	>
	type $bog_theme_toggle__theme_auto_bog_max_app_6 = $mol_type_enforce<
		ReturnType< $bog_max_app['Theme'] >
		,
		ReturnType< $bog_theme_toggle['theme_auto'] >
	>
	type $bog_max_nav__section_bog_max_app_7 = $mol_type_enforce<
		ReturnType< $bog_max_app['section'] >
		,
		ReturnType< $bog_max_nav['section'] >
	>
	type $bog_max_nav__staff_bog_max_app_8 = $mol_type_enforce<
		ReturnType< $bog_max_app['staff'] >
		,
		ReturnType< $bog_max_nav['staff'] >
	>
	type $bog_max_nav__admin_bog_max_app_9 = $mol_type_enforce<
		ReturnType< $bog_max_app['admin'] >
		,
		ReturnType< $bog_max_nav['admin'] >
	>
	type $mol_button_major__title_bog_max_app_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_paragraph__title_bog_max_app_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_max_app_12 = $mol_type_enforce<
		ReturnType< $bog_max_app['row_title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_max_app_13 = $mol_type_enforce<
		ReturnType< $bog_max_app['row_status'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_link__arg_bog_max_app_14 = $mol_type_enforce<
		({ 
			'ticket': ReturnType< $bog_max_app['row_link'] >,
			'screen': any,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_bog_max_app_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_paragraph__title_bog_max_app_16 = $mol_type_enforce<
		ReturnType< $bog_max_app['news_title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_max_app_17 = $mol_type_enforce<
		ReturnType< $bog_max_app['news_when'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_max_app_18 = $mol_type_enforce<
		ReturnType< $bog_max_app['news_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_max_app_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_select__options_bog_max_app_20 = $mol_type_enforce<
		ReturnType< $bog_max_app['house_options'] >
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_select__dictionary_bog_max_app_21 = $mol_type_enforce<
		ReturnType< $bog_max_app['house_dictionary'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_bog_max_app_22 = $mol_type_enforce<
		ReturnType< $bog_max_app['house'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_button_major__title_bog_max_app_23 = $mol_type_enforce<
		ReturnType< $bog_max_app['all_title'] >
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_string__hint_bog_max_app_24 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_max_app_25 = $mol_type_enforce<
		ReturnType< $bog_max_app['house_address_new'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_form_field__name_bog_max_app_26 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__bids_bog_max_app_27 = $mol_type_enforce<
		ReturnType< $bog_max_app['house_address_bids'] >
		,
		ReturnType< $mol_form_field['bids'] >
	>
	type $mol_form_field__control_bog_max_app_28 = $mol_type_enforce<
		ReturnType< $bog_max_app['House_address'] >
		,
		ReturnType< $mol_form_field['control'] >
	>
	type $mol_button_major__title_bog_max_app_29 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_max_app_30 = $mol_type_enforce<
		ReturnType< $bog_max_app['house_add'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_paragraph__title_bog_max_app_31 = $mol_type_enforce<
		ReturnType< $bog_max_app['house_address'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_max_app_32 = $mol_type_enforce<
		ReturnType< $bog_max_app['house_code'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_max_app_33 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_max_app_34 = $mol_type_enforce<
		ReturnType< $bog_max_app['house_remove_title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_minor__hint_bog_max_app_35 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__sub_bog_max_app_36 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_bog_max_app_37 = $mol_type_enforce<
		ReturnType< $bog_max_app['house_remove'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_bog_max_app_38 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_select__options_bog_max_app_39 = $mol_type_enforce<
		ReturnType< $bog_max_app['status_options'] >
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_select__dictionary_bog_max_app_40 = $mol_type_enforce<
		ReturnType< $bog_max_app['status_dictionary'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_bog_max_app_41 = $mol_type_enforce<
		ReturnType< $bog_max_app['admin_status'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_string__hint_bog_max_app_42 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_max_app_43 = $mol_type_enforce<
		ReturnType< $bog_max_app['admin_note'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_select__options_bog_max_app_44 = $mol_type_enforce<
		ReturnType< $bog_max_app['owner_options'] >
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_select__dictionary_bog_max_app_45 = $mol_type_enforce<
		ReturnType< $bog_max_app['owner_dictionary'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_bog_max_app_46 = $mol_type_enforce<
		ReturnType< $bog_max_app['admin_owner'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_paragraph__title_bog_max_app_47 = $mol_type_enforce<
		ReturnType< $bog_max_app['admin_alarm'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_max_app_48 = $mol_type_enforce<
		ReturnType< $bog_max_app['admin_row_sub'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_major__title_bog_max_app_49 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_link__arg_bog_max_app_50 = $mol_type_enforce<
		({ 
			'screen': any,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_bog_max_app_51 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_switch__value_bog_max_app_52 = $mol_type_enforce<
		ReturnType< $bog_max_app['stats_period'] >
		,
		ReturnType< $mol_switch['value'] >
	>
	type $mol_switch__options_bog_max_app_53 = $mol_type_enforce<
		({ 
			'7': string,
			'30': string,
			'90': string,
			'all': string,
		}) 
		,
		ReturnType< $mol_switch['options'] >
	>
	type $mol_select__options_bog_max_app_54 = $mol_type_enforce<
		ReturnType< $bog_max_app['stats_house_options'] >
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_select__dictionary_bog_max_app_55 = $mol_type_enforce<
		ReturnType< $bog_max_app['stats_house_dictionary'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_bog_max_app_56 = $mol_type_enforce<
		ReturnType< $bog_max_app['stats_house'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_view__sub_bog_max_app_57 = $mol_type_enforce<
		ReturnType< $bog_max_app['summary_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_max_app_58 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__rows_bog_max_app_59 = $mol_type_enforce<
		ReturnType< $bog_max_app['owner_stat_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_paragraph__title_bog_max_app_60 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__rows_bog_max_app_61 = $mol_type_enforce<
		ReturnType< $bog_max_app['stats_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_paragraph__title_bog_max_app_62 = $mol_type_enforce<
		ReturnType< $bog_max_app['summary_value'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_max_app_63 = $mol_type_enforce<
		ReturnType< $bog_max_app['summary_label'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_max_app_64 = $mol_type_enforce<
		ReturnType< $bog_max_app['owner_stat_name'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_max_app_65 = $mol_type_enforce<
		ReturnType< $bog_max_app['owner_stat_line'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_max_app_66 = $mol_type_enforce<
		ReturnType< $bog_max_app['stat_house'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_max_app_67 = $mol_type_enforce<
		ReturnType< $bog_max_app['stat_line'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_max_app_68 = $mol_type_enforce<
		ReturnType< $bog_max_app['org_name'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_max_app_69 = $mol_type_enforce<
		ReturnType< $bog_max_app['org_state'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_max_app_70 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_string__hint_bog_max_app_71 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_max_app_72 = $mol_type_enforce<
		ReturnType< $bog_max_app['staff_code'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_paragraph__title_bog_max_app_73 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_switch__value_bog_max_app_74 = $mol_type_enforce<
		ReturnType< $bog_max_app['staff_role'] >
		,
		ReturnType< $mol_switch['value'] >
	>
	type $mol_switch__options_bog_max_app_75 = $mol_type_enforce<
		({ 
			'dispatcher': string,
			'admin': string,
		}) 
		,
		ReturnType< $mol_switch['options'] >
	>
	type $mol_paragraph__title_bog_max_app_76 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_select_list__options_bog_max_app_77 = $mol_type_enforce<
		ReturnType< $bog_max_app['house_options'] >
		,
		ReturnType< $mol_select_list['options'] >
	>
	type $mol_select_list__dictionary_bog_max_app_78 = $mol_type_enforce<
		ReturnType< $bog_max_app['house_dictionary'] >
		,
		ReturnType< $mol_select_list['dictionary'] >
	>
	type $mol_select_list__value_bog_max_app_79 = $mol_type_enforce<
		ReturnType< $bog_max_app['staff_houses'] >
		,
		ReturnType< $mol_select_list['value'] >
	>
	type $mol_select_list__pick_hint_bog_max_app_80 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_select_list['pick_hint'] >
	>
	type $mol_button_major__title_bog_max_app_81 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_max_app_82 = $mol_type_enforce<
		ReturnType< $bog_max_app['staff_add'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_string__hint_bog_max_app_83 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_max_app_84 = $mol_type_enforce<
		ReturnType< $bog_max_app['post_title'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_form_field__name_bog_max_app_85 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__bids_bog_max_app_86 = $mol_type_enforce<
		ReturnType< $bog_max_app['post_title_bids'] >
		,
		ReturnType< $mol_form_field['bids'] >
	>
	type $mol_form_field__control_bog_max_app_87 = $mol_type_enforce<
		ReturnType< $bog_max_app['Post_title_input'] >
		,
		ReturnType< $mol_form_field['control'] >
	>
	type $mol_string__hint_bog_max_app_88 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_max_app_89 = $mol_type_enforce<
		ReturnType< $bog_max_app['post_text'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_form_field__name_bog_max_app_90 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__control_bog_max_app_91 = $mol_type_enforce<
		ReturnType< $bog_max_app['Post_text_input'] >
		,
		ReturnType< $mol_form_field['control'] >
	>
	type $mol_select__options_bog_max_app_92 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_select__dictionary_bog_max_app_93 = $mol_type_enforce<
		({ 
			'news': string,
			'outage': string,
		}) 
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_bog_max_app_94 = $mol_type_enforce<
		ReturnType< $bog_max_app['post_kind'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_form_field__name_bog_max_app_95 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__control_bog_max_app_96 = $mol_type_enforce<
		ReturnType< $bog_max_app['Post_kind'] >
		,
		ReturnType< $mol_form_field['control'] >
	>
	type $mol_select__options_bog_max_app_97 = $mol_type_enforce<
		ReturnType< $bog_max_app['my_houses'] >
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_select__dictionary_bog_max_app_98 = $mol_type_enforce<
		ReturnType< $bog_max_app['house_dictionary'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_bog_max_app_99 = $mol_type_enforce<
		ReturnType< $bog_max_app['post_house'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_form_field__name_bog_max_app_100 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__control_bog_max_app_101 = $mol_type_enforce<
		ReturnType< $bog_max_app['Post_house'] >
		,
		ReturnType< $mol_form_field['control'] >
	>
	type $mol_button_major__title_bog_max_app_102 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_max_app_103 = $mol_type_enforce<
		ReturnType< $bog_max_app['post_add'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_link__arg_bog_max_app_104 = $mol_type_enforce<
		({ 
			'screen': any,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_bog_max_app_105 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_select__options_bog_max_app_106 = $mol_type_enforce<
		ReturnType< $bog_max_app['house_options'] >
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_select__dictionary_bog_max_app_107 = $mol_type_enforce<
		ReturnType< $bog_max_app['house_dictionary'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_bog_max_app_108 = $mol_type_enforce<
		ReturnType< $bog_max_app['house'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_form_field__name_bog_max_app_109 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__control_bog_max_app_110 = $mol_type_enforce<
		ReturnType< $bog_max_app['House_new'] >
		,
		ReturnType< $mol_form_field['control'] >
	>
	type $bog_max_pick__options_bog_max_app_111 = $mol_type_enforce<
		ReturnType< $bog_max_app['scope_options'] >
		,
		ReturnType< $bog_max_pick['options'] >
	>
	type $bog_max_pick__dictionary_bog_max_app_112 = $mol_type_enforce<
		ReturnType< $bog_max_app['scope_dictionary'] >
		,
		ReturnType< $bog_max_pick['dictionary'] >
	>
	type $bog_max_pick__value_bog_max_app_113 = $mol_type_enforce<
		ReturnType< $bog_max_app['scope'] >
		,
		ReturnType< $bog_max_pick['value'] >
	>
	type $bog_max_pick__custom_bog_max_app_114 = $mol_type_enforce<
		ReturnType< $bog_max_app['scope_custom'] >
		,
		ReturnType< $bog_max_pick['custom'] >
	>
	type $mol_form_field__name_bog_max_app_115 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__control_bog_max_app_116 = $mol_type_enforce<
		ReturnType< $bog_max_app['Scope'] >
		,
		ReturnType< $mol_form_field['control'] >
	>
	type $bog_max_pick__options_bog_max_app_117 = $mol_type_enforce<
		ReturnType< $bog_max_app['category_options'] >
		,
		ReturnType< $bog_max_pick['options'] >
	>
	type $bog_max_pick__dictionary_bog_max_app_118 = $mol_type_enforce<
		ReturnType< $bog_max_app['category_dictionary'] >
		,
		ReturnType< $bog_max_pick['dictionary'] >
	>
	type $bog_max_pick__value_bog_max_app_119 = $mol_type_enforce<
		ReturnType< $bog_max_app['category'] >
		,
		ReturnType< $bog_max_pick['value'] >
	>
	type $bog_max_pick__custom_bog_max_app_120 = $mol_type_enforce<
		ReturnType< $bog_max_app['category_custom'] >
		,
		ReturnType< $bog_max_pick['custom'] >
	>
	type $mol_form_field__name_bog_max_app_121 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__attr_bog_max_app_122 = $mol_type_enforce<
		({ 
			'bog_max_required': string,
		})  & ReturnType< $mol_form_field['attr'] >
		,
		ReturnType< $mol_form_field['attr'] >
	>
	type $mol_form_field__bids_bog_max_app_123 = $mol_type_enforce<
		ReturnType< $bog_max_app['category_bids'] >
		,
		ReturnType< $mol_form_field['bids'] >
	>
	type $mol_form_field__control_bog_max_app_124 = $mol_type_enforce<
		ReturnType< $bog_max_app['Category'] >
		,
		ReturnType< $mol_form_field['control'] >
	>
	type $mol_string__hint_bog_max_app_125 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_max_app_126 = $mol_type_enforce<
		ReturnType< $bog_max_app['entrance'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_form_field__name_bog_max_app_127 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__control_bog_max_app_128 = $mol_type_enforce<
		ReturnType< $bog_max_app['Entrance'] >
		,
		ReturnType< $mol_form_field['control'] >
	>
	type $mol_string__hint_bog_max_app_129 = $mol_type_enforce<
		ReturnType< $bog_max_app['place_hint'] >
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_max_app_130 = $mol_type_enforce<
		ReturnType< $bog_max_app['place'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_form_field__name_bog_max_app_131 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__attr_bog_max_app_132 = $mol_type_enforce<
		({ 
			'bog_max_required': string,
		})  & ReturnType< $mol_form_field['attr'] >
		,
		ReturnType< $mol_form_field['attr'] >
	>
	type $mol_form_field__bids_bog_max_app_133 = $mol_type_enforce<
		ReturnType< $bog_max_app['place_bids'] >
		,
		ReturnType< $mol_form_field['bids'] >
	>
	type $mol_form_field__control_bog_max_app_134 = $mol_type_enforce<
		ReturnType< $bog_max_app['Place'] >
		,
		ReturnType< $mol_form_field['control'] >
	>
	type $mol_string__hint_bog_max_app_135 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_max_app_136 = $mol_type_enforce<
		ReturnType< $bog_max_app['text'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_form_field__name_bog_max_app_137 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__control_bog_max_app_138 = $mol_type_enforce<
		ReturnType< $bog_max_app['Text'] >
		,
		ReturnType< $mol_form_field['control'] >
	>
	type $mol_button_open__files_bog_max_app_139 = $mol_type_enforce<
		ReturnType< $bog_max_app['photo_picked'] >
		,
		ReturnType< $mol_button_open['files'] >
	>
	type $mol_button_open__accept_bog_max_app_140 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_open['accept'] >
	>
	type $mol_button_open__multiple_bog_max_app_141 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_button_open['multiple'] >
	>
	type $mol_button_open__hint_bog_max_app_142 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_open['hint'] >
	>
	type $mol_paragraph__title_bog_max_app_143 = $mol_type_enforce<
		ReturnType< $bog_max_app['photo_pick_label'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_max_app_144 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_max_app_145 = $mol_type_enforce<
		ReturnType< $bog_max_app['photo_previews'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_max_app_146 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_form_field__name_bog_max_app_147 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__control_bog_max_app_148 = $mol_type_enforce<
		ReturnType< $bog_max_app['Photo_box'] >
		,
		ReturnType< $mol_form_field['control'] >
	>
	type $mol_button_major__title_bog_max_app_149 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_max_app_150 = $mol_type_enforce<
		ReturnType< $bog_max_app['submit'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_paragraph__title_bog_max_app_151 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_image__uri_bog_max_app_152 = $mol_type_enforce<
		ReturnType< $bog_max_app['chat_url'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_image__loading_bog_max_app_153 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_image['loading'] >
	>
	type $mol_link__uri_bog_max_app_154 = $mol_type_enforce<
		ReturnType< $bog_max_app['chat_url'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__target_bog_max_app_155 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['target'] >
	>
	type $mol_link__sub_bog_max_app_156 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_view__dom_name_bog_max_app_157 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__attr_bog_max_app_158 = $mol_type_enforce<
		({ 
			'src': ReturnType< $bog_max_app['chat_url'] >,
			'controls': string,
			'playsinline': string,
		}) 
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_button_minor__hint_bog_max_app_159 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__sub_bog_max_app_160 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_bog_max_app_161 = $mol_type_enforce<
		ReturnType< $bog_max_app['chat_drop'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_image__uri_bog_max_app_162 = $mol_type_enforce<
		ReturnType< $bog_max_app['photo_url'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_image__loading_bog_max_app_163 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_image['loading'] >
	>
	type $mol_link__uri_bog_max_app_164 = $mol_type_enforce<
		ReturnType< $bog_max_app['photo_url'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__target_bog_max_app_165 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['target'] >
	>
	type $mol_link__sub_bog_max_app_166 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_view__dom_name_bog_max_app_167 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__attr_bog_max_app_168 = $mol_type_enforce<
		({ 
			'src': ReturnType< $bog_max_app['photo_url'] >,
			'controls': string,
			'playsinline': string,
		}) 
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_button_minor__hint_bog_max_app_169 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__sub_bog_max_app_170 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_bog_max_app_171 = $mol_type_enforce<
		ReturnType< $bog_max_app['photo_drop'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_link__arg_bog_max_app_172 = $mol_type_enforce<
		({ 
			'screen': any,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_bog_max_app_173 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_search__query_bog_max_app_174 = $mol_type_enforce<
		ReturnType< $bog_max_app['all_query'] >
		,
		ReturnType< $mol_search['query'] >
	>
	type $mol_search__hint_bog_max_app_175 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_search['hint'] >
	>
	type $mol_select__options_bog_max_app_176 = $mol_type_enforce<
		ReturnType< $bog_max_app['all_status_options'] >
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_select__dictionary_bog_max_app_177 = $mol_type_enforce<
		ReturnType< $bog_max_app['all_status_dictionary'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_bog_max_app_178 = $mol_type_enforce<
		ReturnType< $bog_max_app['all_status'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_list__rows_bog_max_app_179 = $mol_type_enforce<
		ReturnType< $bog_max_app['all_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_link__arg_bog_max_app_180 = $mol_type_enforce<
		({ 
			'ticket': any,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_bog_max_app_181 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_view__sub_bog_max_app_182 = $mol_type_enforce<
		ReturnType< $bog_max_app['ticket_item_sub'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_image__uri_bog_max_app_183 = $mol_type_enforce<
		ReturnType< $bog_max_app['ticket_media_url'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_image__loading_bog_max_app_184 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_image['loading'] >
	>
	type $mol_link__uri_bog_max_app_185 = $mol_type_enforce<
		ReturnType< $bog_max_app['ticket_media_url'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__target_bog_max_app_186 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['target'] >
	>
	type $mol_link__sub_bog_max_app_187 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_view__dom_name_bog_max_app_188 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__attr_bog_max_app_189 = $mol_type_enforce<
		({ 
			'src': ReturnType< $bog_max_app['ticket_media_url'] >,
			'controls': string,
			'playsinline': string,
		}) 
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_paragraph__title_bog_max_app_190 = $mol_type_enforce<
		ReturnType< $bog_max_app['ticket_alarm_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_minor__title_bog_max_app_191 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_max_app_192 = $mol_type_enforce<
		ReturnType< $bog_max_app['alarm'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__enabled_bog_max_app_193 = $mol_type_enforce<
		ReturnType< $bog_max_app['alarm_allowed'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_paragraph__title_bog_max_app_194 = $mol_type_enforce<
		ReturnType< $bog_max_app['voices_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_major__title_bog_max_app_195 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_max_app_196 = $mol_type_enforce<
		ReturnType< $bog_max_app['voice'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__enabled_bog_max_app_197 = $mol_type_enforce<
		ReturnType< $bog_max_app['voice_allowed'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_paragraph__title_bog_max_app_198 = $mol_type_enforce<
		ReturnType< $bog_max_app['log_row'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_page__title_bog_max_app_199 = $mol_type_enforce<
		ReturnType< $bog_max_app['main_title'] >
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__Logo_bog_max_app_200 = $mol_type_enforce<
		ReturnType< $bog_max_app['Max_logo'] >
		,
		ReturnType< $mol_page['Logo'] >
	>
	type $mol_page__tools_bog_max_app_201 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_bog_max_app_202 = $mol_type_enforce<
		ReturnType< $bog_max_app['main_body'] >
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_page__foot_bog_max_app_203 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['foot'] >
	>
	type $mol_paragraph__title_bog_max_app_204 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_max_app_205 = $mol_type_enforce<
		ReturnType< $bog_max_app['fail'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_minor__title_bog_max_app_206 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_max_app_207 = $mol_type_enforce<
		ReturnType< $bog_max_app['reset'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_link__arg_bog_max_app_208 = $mol_type_enforce<
		({ 
			'screen': string,
			'ticket': any,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_bog_max_app_209 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_paragraph__title_bog_max_app_210 = $mol_type_enforce<
		ReturnType< $bog_max_app['house_title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_max_app_211 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_max_app_212 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__rows_bog_max_app_213 = $mol_type_enforce<
		ReturnType< $bog_max_app['rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_select__options_bog_max_app_214 = $mol_type_enforce<
		ReturnType< $bog_max_app['house_options'] >
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_select__dictionary_bog_max_app_215 = $mol_type_enforce<
		ReturnType< $bog_max_app['house_dictionary'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_bog_max_app_216 = $mol_type_enforce<
		ReturnType< $bog_max_app['house'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_switch__value_bog_max_app_217 = $mol_type_enforce<
		ReturnType< $bog_max_app['house_tab'] >
		,
		ReturnType< $mol_switch['value'] >
	>
	type $mol_switch__options_bog_max_app_218 = $mol_type_enforce<
		({ 
			'tickets': string,
			'news': string,
		}) 
		,
		ReturnType< $mol_switch['options'] >
	>
	type $mol_search__query_bog_max_app_219 = $mol_type_enforce<
		ReturnType< $bog_max_app['query'] >
		,
		ReturnType< $mol_search['query'] >
	>
	type $mol_search__hint_bog_max_app_220 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_search['hint'] >
	>
	type $mol_paragraph__title_bog_max_app_221 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__rows_bog_max_app_222 = $mol_type_enforce<
		ReturnType< $bog_max_app['house_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_paragraph__title_bog_max_app_223 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__rows_bog_max_app_224 = $mol_type_enforce<
		ReturnType< $bog_max_app['news_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_bog_max_app_225 = $mol_type_enforce<
		ReturnType< $bog_max_app['account_head'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_image__uri_bog_max_app_226 = $mol_type_enforce<
		ReturnType< $bog_max_app['account_photo'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_image__title_bog_max_app_227 = $mol_type_enforce<
		ReturnType< $bog_max_app['account_name'] >
		,
		ReturnType< $mol_image['title'] >
	>
	type $mol_avatar__id_bog_max_app_228 = $mol_type_enforce<
		ReturnType< $bog_max_app['account_id'] >
		,
		ReturnType< $mol_avatar['id'] >
	>
	type $mol_view__sub_bog_max_app_229 = $mol_type_enforce<
		ReturnType< $bog_max_app['account_titles'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_max_app_230 = $mol_type_enforce<
		ReturnType< $bog_max_app['account_name'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_max_app_231 = $mol_type_enforce<
		ReturnType< $bog_max_app['account_username'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_labeler__title_bog_max_app_232 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_max_app_233 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_form_field__name_bog_max_app_234 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__control_bog_max_app_235 = $mol_type_enforce<
		ReturnType< $bog_max_app['House'] >
		,
		ReturnType< $mol_form_field['control'] >
	>
	type $mol_labeler__title_bog_max_app_236 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_max_app_237 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_paragraph__title_bog_max_app_238 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_labeler__title_bog_max_app_239 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_max_app_240 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_labeler__title_bog_max_app_241 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_max_app_242 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_paragraph__title_bog_max_app_243 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_max_app_244 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_max_app_245 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_link__arg_bog_max_app_246 = $mol_type_enforce<
		({ 
			'screen': string,
			'ticket': any,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_bog_max_app_247 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_form__form_fields_bog_max_app_248 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form['form_fields'] >
	>
	type $mol_form__buttons_bog_max_app_249 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form['buttons'] >
	>
	type $mol_paragraph__title_bog_max_app_250 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__rows_bog_max_app_251 = $mol_type_enforce<
		ReturnType< $bog_max_app['admin_house_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_paragraph__title_bog_max_app_252 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__rows_bog_max_app_253 = $mol_type_enforce<
		ReturnType< $bog_max_app['admin_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_link__arg_bog_max_app_254 = $mol_type_enforce<
		({ 
			'screen': string,
			'ticket': any,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_bog_max_app_255 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_page__title_bog_max_app_256 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__tools_bog_max_app_257 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_bog_max_app_258 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_view__sub_bog_max_app_259 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_max_app_260 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_max_app_261 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_max_app_262 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__rows_bog_max_app_263 = $mol_type_enforce<
		ReturnType< $bog_max_app['org_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_paragraph__title_bog_max_app_264 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_select__options_bog_max_app_265 = $mol_type_enforce<
		ReturnType< $bog_max_app['my_houses'] >
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_select__dictionary_bog_max_app_266 = $mol_type_enforce<
		ReturnType< $bog_max_app['house_dictionary'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_bog_max_app_267 = $mol_type_enforce<
		ReturnType< $bog_max_app['qr_house'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $bog_qr__uri_bog_max_app_268 = $mol_type_enforce<
		ReturnType< $bog_max_app['qr_uri'] >
		,
		ReturnType< $bog_qr['uri'] >
	>
	type $mol_paragraph__title_bog_max_app_269 = $mol_type_enforce<
		ReturnType< $bog_max_app['qr_uri'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_major__title_bog_max_app_270 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_max_app_271 = $mol_type_enforce<
		ReturnType< $bog_max_app['qr_print'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_paragraph__title_bog_max_app_272 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_max_app_273 = $mol_type_enforce<
		ReturnType< $bog_max_app['staff_link'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $bog_qr__uri_bog_max_app_274 = $mol_type_enforce<
		ReturnType< $bog_max_app['staff_link'] >
		,
		ReturnType< $bog_qr['uri'] >
	>
	type $mol_view__sub_bog_max_app_275 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_form__form_fields_bog_max_app_276 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form['form_fields'] >
	>
	type $mol_form__buttons_bog_max_app_277 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form['buttons'] >
	>
	type $mol_page__title_bog_max_app_278 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__tools_bog_max_app_279 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_bog_max_app_280 = $mol_type_enforce<
		ReturnType< $bog_max_app['new_body'] >
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_labeler__title_bog_max_app_281 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_max_app_282 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_form__body_bog_max_app_283 = $mol_type_enforce<
		ReturnType< $bog_max_app['new_fields'] >
		,
		ReturnType< $mol_form['body'] >
	>
	type $mol_form__form_fields_bog_max_app_284 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form['form_fields'] >
	>
	type $mol_form__buttons_bog_max_app_285 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form['buttons'] >
	>
	type $mol_view__sub_bog_max_app_286 = $mol_type_enforce<
		ReturnType< $bog_max_app['chat_item_sub'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_max_app_287 = $mol_type_enforce<
		ReturnType< $bog_max_app['photo_item_sub'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_max_app_288 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__rows_bog_max_app_289 = $mol_type_enforce<
		ReturnType< $bog_max_app['similar_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_page__title_bog_max_app_290 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__tools_bog_max_app_291 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_bog_max_app_292 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_page__title_bog_max_app_293 = $mol_type_enforce<
		ReturnType< $bog_max_app['ticket_title'] >
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__tools_bog_max_app_294 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_bog_max_app_295 = $mol_type_enforce<
		ReturnType< $bog_max_app['ticket_body'] >
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_paragraph__title_bog_max_app_296 = $mol_type_enforce<
		ReturnType< $bog_max_app['ticket_status'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_max_app_297 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_max_app_298 = $mol_type_enforce<
		ReturnType< $bog_max_app['ticket_note'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_max_app_299 = $mol_type_enforce<
		ReturnType< $bog_max_app['ticket_media'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_labeler__title_bog_max_app_300 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_max_app_301 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_labeler__title_bog_max_app_302 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_max_app_303 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_labeler__title_bog_max_app_304 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_max_app_305 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_labeler__title_bog_max_app_306 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_max_app_307 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_labeler__title_bog_max_app_308 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_max_app_309 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_view__sub_bog_max_app_310 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_labeler__title_bog_max_app_311 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_max_app_312 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_labeler__title_bog_max_app_313 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_max_app_314 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_labeler__title_bog_max_app_315 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_max_app_316 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_view__sub_bog_max_app_317 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_bog_max_app_318 = $mol_type_enforce<
		ReturnType< $bog_max_app['log_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	export class $bog_max_app extends $mol_book2 {
		platform( ): string
		Theme( ): $bog_theme_auto
		main_title( ): string
		Max_logo( ): $mol_image
		Sync( ): $giper_baza_status
		Theme_toggle( ): $bog_theme_toggle
		main_body( ): readonly(any)[]
		section( ): string
		staff( ): boolean
		admin( ): boolean
		Nav( ): $bog_max_nav
		fail( ): string
		reset( next?: any ): any
		New_button( ): $mol_button_major
		house_title( ): string
		House_missing_icon( ): $mol_icon_camera
		House_missing_text( ): $mol_paragraph
		row_link( id: any): string
		row_title( id: any): string
		Row_title( id: any): $mol_paragraph
		row_status( id: any): string
		Row_status( id: any): $mol_paragraph
		Row( id: any): $mol_link
		rows( ): readonly(any)[]
		house_options( ): readonly(string)[]
		house_dictionary( ): Record<string, any>
		house( next?: string ): string
		house_tab( next?: string ): string
		query( next?: string ): string
		house_rows( ): readonly(any)[]
		news_title( id: any): string
		Post_title( id: any): $mol_paragraph
		news_when( id: any): string
		Post_when( id: any): $mol_paragraph
		news_text( id: any): string
		Post_text( id: any): $mol_paragraph
		Post( id: any): $mol_view
		news_rows( ): readonly(any)[]
		account_head( ): readonly(any)[]
		account_photo( ): string
		account_name( ): string
		account_id( ): string
		account_titles( ): readonly(any)[]
		account_username( ): string
		House( ): $mol_select
		account_count( ): string
		account_role( ): string
		account_code( ): string
		all_title( ): string
		All_button( ): $mol_button_major
		house_allowed( ): ReturnType< ReturnType< $bog_max_app['House_form'] >['submit_allowed'] >
		house_address_bids( ): readonly(string)[]
		house_address_new( next?: string ): string
		House_address( ): $mol_string
		House_address_field( ): $mol_form_field
		house_add( next?: any ): any
		House_submit( ): $mol_button_major
		house_address( ): string
		Admin_house_address( id: any): $mol_paragraph
		house_code( id: any): string
		Admin_house_code( id: any): $mol_paragraph
		Admin_house_info( id: any): $mol_view
		House_remove_icon( id: any): $mol_icon_delete
		house_remove_title( id: any): string
		House_remove_label( id: any): $mol_paragraph
		house_remove( id: any, next?: any ): any
		House_remove( id: any): $mol_button_minor
		Admin_house( id: any): $mol_view
		admin_house_rows( ): readonly(any)[]
		status_options( ): readonly(string)[]
		status_dictionary( ): Record<string, any>
		admin_status( id: any, next?: string ): string
		Admin_status( id: any): $mol_select
		admin_note( id: any, next?: string ): string
		Admin_note( id: any): $mol_string
		owner_options( ): readonly(string)[]
		owner_dictionary( ): Record<string, any>
		admin_owner( id: any, next?: string ): string
		Admin_owner( id: any): $mol_select
		admin_alarm( id: any): string
		Admin_alarm( id: any): $mol_paragraph
		admin_row_sub( id: any): readonly(any)[]
		Admin_row( id: any): $mol_view
		admin_rows( ): readonly(any)[]
		Stats_button( ): $mol_button_major
		Close_stats_icon( ): $mol_icon_close
		Close_stats( ): $mol_link
		stats_period( next?: string ): string
		Stats_period( ): $mol_switch
		stats_house_options( ): readonly(string)[]
		stats_house_dictionary( ): Record<string, any>
		stats_house( next?: string ): string
		Stats_house_pick( ): $mol_select
		summary_rows( ): readonly(any)[]
		Stats_summary( ): $mol_view
		Stats_owners_title( ): $mol_paragraph
		owner_stat_rows( ): readonly(any)[]
		Stats_owners( ): $mol_list
		Stats_houses_title( ): $mol_paragraph
		stats_rows( ): readonly(any)[]
		Stats_houses( ): $mol_list
		summary_value( id: any): string
		Summary_value( id: any): $mol_paragraph
		summary_label( id: any): string
		Summary_label( id: any): $mol_paragraph
		owner_stat_name( id: any): string
		Owner_stat_name( id: any): $mol_paragraph
		owner_stat_line( id: any): string
		Owner_stat_line( id: any): $mol_paragraph
		stat_house( id: any): string
		Stat_house( id: any): $mol_paragraph
		stat_line( id: any): string
		Stat_line( id: any): $mol_paragraph
		org_name( id: any): string
		Org_name( id: any): $mol_paragraph
		org_state( id: any): string
		Org_state( id: any): $mol_paragraph
		Org( id: any): $mol_view
		org_rows( ): readonly(any)[]
		my_houses( ): readonly(string)[]
		qr_house( next?: string ): string
		qr_uri( ): string
		qr_print( next?: any ): any
		staff_link( ): string
		staff_code( next?: string ): string
		Staff_code( ): $mol_string
		Staff_role_label( ): $mol_paragraph
		staff_role( next?: string ): string
		Staff_role( ): $mol_switch
		Staff_houses_label( ): $mol_paragraph
		staff_houses( next?: readonly(string)[] ): readonly(string)[]
		Staff_houses( ): $mol_select_list
		staff_add( next?: any ): any
		Staff_add( ): $mol_button_major
		post_allowed( ): ReturnType< ReturnType< $bog_max_app['Post_form'] >['submit_allowed'] >
		post_title_bids( ): readonly(string)[]
		post_title( next?: string ): string
		Post_title_input( ): $mol_string
		Post_title_field( ): $mol_form_field
		post_text( next?: string ): string
		Post_text_input( ): $mol_string
		Post_text_field( ): $mol_form_field
		post_kind( next?: string ): string
		Post_kind( ): $mol_select
		Post_kind_field( ): $mol_form_field
		post_house( next?: string ): string
		Post_house( ): $mol_select
		Post_house_field( ): $mol_form_field
		post_add( next?: any ): any
		Post_submit( ): $mol_button_major
		Close_new_icon( ): $mol_icon_close
		Close_new( ): $mol_link
		new_body( ): readonly(any)[]
		submit_allowed( ): ReturnType< ReturnType< $bog_max_app['Form'] >['submit_allowed'] >
		new_fields( ): readonly(any)[]
		House_new( ): $mol_select
		House_field( ): $mol_form_field
		scope_options( ): readonly(string)[]
		scope_dictionary( ): Record<string, any>
		scope( next?: string ): string
		scope_custom( next?: string ): string
		Scope( ): $bog_max_pick
		Scope_field( ): $mol_form_field
		category_bids( ): readonly(string)[]
		category_options( ): readonly(string)[]
		category_dictionary( ): Record<string, any>
		category( next?: string ): string
		category_custom( next?: string ): string
		Category( ): $bog_max_pick
		Category_field( ): $mol_form_field
		entrance( next?: string ): string
		Entrance( ): $mol_string
		Entrance_field( ): $mol_form_field
		place_bids( ): readonly(string)[]
		place_hint( ): string
		place( next?: string ): string
		Place( ): $mol_string
		Place_field( ): $mol_form_field
		text( next?: string ): string
		Text( ): $mol_string
		Text_field( ): $mol_form_field
		photo_picked( next?: readonly(File)[] ): readonly(File)[]
		Photo_pick( ): $mol_button_open
		photo_pick_label( ): string
		Photo_name( ): $mol_paragraph
		Photo_row( ): $mol_view
		photo_previews( ): readonly(any)[]
		Photo_previews( ): $mol_view
		Photo_box( ): $mol_view
		Photo_field( ): $mol_form_field
		submit( next?: any ): any
		Submit( ): $mol_button_major
		Consent( ): $mol_paragraph
		chat_url( id: any): string
		Chat_thumb( id: any): $mol_image
		Chat_open( id: any): $mol_link
		Chat_video( id: any): $mol_view
		Chat_drop_icon( id: any): $mol_icon_close
		chat_drop( id: any, next?: any ): any
		Chat_drop( id: any): $mol_button_minor
		chat_item_sub( id: any): readonly(any)[]
		photo_url( id: any): string
		Photo_thumb( id: any): $mol_image
		Photo_open( id: any): $mol_link
		Photo_video( id: any): $mol_view
		Photo_drop_icon( id: any): $mol_icon_close
		photo_drop( id: any, next?: any ): any
		Photo_drop( id: any): $mol_button_minor
		photo_item_sub( id: any): readonly(any)[]
		similar_rows( ): readonly(any)[]
		Close_all_icon( ): $mol_icon_close
		Close_all( ): $mol_link
		all_query( next?: string ): string
		All_search( ): $mol_search
		all_status_options( ): readonly(string)[]
		all_status_dictionary( ): Record<string, any>
		all_status( next?: string ): string
		All_status( ): $mol_select
		all_rows( ): readonly(any)[]
		All_rows( ): $mol_list
		ticket_title( ): string
		Close_ticket_icon( ): $mol_icon_close
		Close_ticket( ): $mol_link
		ticket_body( ): readonly(any)[]
		ticket_status( ): string
		ticket_note( ): string
		ticket_item_sub( id: any): readonly(any)[]
		Ticket_item( id: any): $mol_view
		ticket_media_url( id: any): string
		Ticket_image_pic( id: any): $mol_image
		Ticket_image( id: any): $mol_link
		Ticket_video( id: any): $mol_view
		ticket_media( ): readonly(any)[]
		ticket_category( ): string
		ticket_house( ): string
		ticket_place( ): string
		ticket_text( ): string
		ticket_owner( ): string
		ticket_alarm_text( ): string
		Ticket_alarm_text( ): $mol_paragraph
		alarm( next?: any ): any
		alarm_allowed( ): boolean
		Alarm( ): $mol_button_minor
		ticket_react( ): string
		ticket_fix( ): string
		ticket_basis( ): string
		voices_text( ): string
		Voices_count( ): $mol_paragraph
		voice( next?: any ): any
		voice_allowed( ): boolean
		Voice( ): $mol_button_major
		log_row( id: any): string
		Log_row( id: any): $mol_paragraph
		log_rows( ): readonly(any)[]
		bot_prod( ): string
		attr( ): ({ 
			'bog_max_platform': ReturnType< $bog_max_app['platform'] >,
		})  & ReturnType< $mol_book2['attr'] >
		plugins( ): readonly(any)[]
		pages( ): readonly(any)[]
		placeholders( ): readonly(any)[]
		Main( ): $mol_page
		Wait( ): $mol_paragraph
		Fail( ): $mol_paragraph
		Reset( ): $mol_button_minor
		New_link( ): $mol_link
		House_title( ): $mol_paragraph
		House_missing( ): $mol_view
		Empty( ): $mol_paragraph
		Rows( ): $mol_list
		House_pick( ): $mol_select
		House_tabs( ): $mol_switch
		Search( ): $mol_search
		House_empty( ): $mol_paragraph
		House_rows( ): $mol_list
		News_empty( ): $mol_paragraph
		News( ): $mol_list
		Account_head( ): $mol_view
		Account_photo( ): $mol_image
		Account_avatar( ): $mol_avatar
		Account_titles( ): $mol_view
		Account_name( ): $mol_paragraph
		Account_username( ): $mol_paragraph
		Account_id( ): $mol_labeler
		Account_house( ): $mol_form_field
		Account_count( ): $mol_labeler
		Account_note( ): $mol_paragraph
		Account_role( ): $mol_labeler
		Account_code( ): $mol_labeler
		Account_code_note( ): $mol_paragraph
		Account_demo( ): $mol_paragraph
		Admin_title( ): $mol_paragraph
		All_link( ): $mol_link
		House_form( ): $mol_form
		Houses_title( ): $mol_paragraph
		Admin_houses( ): $mol_list
		Admin_empty( ): $mol_paragraph
		Admin_rows( ): $mol_list
		Stats_link( ): $mol_link
		Stats( ): $mol_page
		Summary( id: any): $mol_view
		Owner_stat( id: any): $mol_view
		Stat( id: any): $mol_view
		Orgs_title( ): $mol_paragraph
		Orgs( ): $mol_list
		Qr_title( ): $mol_paragraph
		Qr_house( ): $mol_select
		Qr( ): $bog_qr
		Qr_link( ): $mol_paragraph
		Qr_print( ): $mol_button_major
		Staff_title( ): $mol_paragraph
		Staff_invite( ): $mol_paragraph
		Staff_qr( ): $bog_qr
		Staff_form( ): $mol_view
		Post_form( ): $mol_form
		New( ): $mol_page
		House_line( ): $mol_labeler
		Form( ): $mol_form
		Chat_item( id: any): $mol_view
		Photo_item( id: any): $mol_view
		Similar_title( ): $mol_paragraph
		Similar( ): $mol_list
		All( ): $mol_page
		Ticket( ): $mol_page
		Ticket_status( ): $mol_paragraph
		Ticket_uploading( ): $mol_paragraph
		Ticket_note( ): $mol_paragraph
		Ticket_media( ): $mol_view
		Ticket_category( ): $mol_labeler
		Ticket_house( ): $mol_labeler
		Ticket_place( ): $mol_labeler
		Ticket_text( ): $mol_labeler
		Ticket_owner( ): $mol_labeler
		Ticket_alarm( ): $mol_view
		Ticket_react( ): $mol_labeler
		Ticket_fix( ): $mol_labeler
		Ticket_basis( ): $mol_labeler
		Voices( ): $mol_view
		Log( ): $mol_list
	}
	
}

//# sourceMappingURL=app.view.tree.d.ts.map